import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import * as Form from 'components/_core/form';
import IconButton from 'components/_core/IconButton';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import BooleanRadioGroup from 'features/Onboarding/components/BooleanRadioGroup';
import EditPersonalNameFields from 'features/Onboarding/legacy/components/EditPersonalNameFields';

import locales from '../locales';
import { NewBeneficiaryFormProps } from '../types';

const NewBeneficiaryCard: FC<NewBeneficiaryFormProps> = ({
  hasSetEligibility,
  isFormValid,
  isValidBeneficiary,
  loading,
  onChange,
  onRemove,
  onSubmit,
  values,
}) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    <SunshineCard.Group>
      <SunshineCard>
        <Flex justifyContent="space-between" marginBottom="space-16">
          <Text fontWeight="weight-500" variant="primary">
            {locales.newBeneficiaryCardTitle}
          </Text>
          <IconButton
            aria-label="delete"
            icon="trash"
            onClick={onRemove}
            size="sm"
            variant="secondary"
          />
        </Flex>

        <EditPersonalNameFields
          firstName={values.firstName}
          gender={values.gender}
          lastName={values.lastName}
          onFirstNameChange={(v) => onChange('firstName', v)}
          onGenderChange={(v) => onChange('gender', v)}
          onLastNameChange={(v) => onChange('lastName', v)}
        />

        <Form.Field label={locales.inviteeEmail} marginY="space-24">
          <Form.Input
            onChange={(event) => {
              onChange('inviteeEmail', event.target.value);
            }}
            required
            type="email"
            value={values.inviteeEmail}
          />
        </Form.Field>

        <Text fontWeight="weight-500" variant="primary">
          {locales.directorLabel}
        </Text>
        <Text marginBottom="space-16">{locales.directorDescription}</Text>
        <Form.Field marginBottom="space-24">
          <BooleanRadioGroup
            onChange={(value) => onChange('isDirector', value)}
            value={values.isDirector}
          />
        </Form.Field>

        <Text fontWeight="weight-500" variant="primary">
          {locales.majorShareholderLabel}
        </Text>
        <Text marginBottom="space-16">
          {locales.majorShareholderDescription}
        </Text>
        <Form.Field marginBottom="space-24">
          <BooleanRadioGroup
            onChange={(value) => onChange('isMajorShareholder', value)}
            value={values.isMajorShareholder}
          />
        </Form.Field>

        {!hasSetEligibility || isValidBeneficiary ? null : (
          <Callout variant="error">
            <Callout.Content>{locales.invalidMessage}</Callout.Content>
          </Callout>
        )}
      </SunshineCard>
      <SunshineCard textAlign="center">
        <Button
          isDisabled={!isFormValid}
          isExpanded
          isLoading={loading}
          type="submit"
        >
          {locales.saveNewBeneficiary}
        </Button>
      </SunshineCard>
    </SunshineCard.Group>
  </form>
);

export default NewBeneficiaryCard;
